export default [
  {
    path: 'phase-3/:id',
    props: true,
    name: 'onBoard.neofintech.phase3',
    children: [
      {
        path: 'congratulations',
        name: 'onBoard.neofintech.phase3.congratulations',
        meta: {
          prev: null,
          next: 'onBoard.neofintech.phase3.info',
          name: 'Enhorabuena',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#FFC10D', 
              dark: '#cc9a09',
              helpModal: '#8cc63f'
            },
            step: {
              number: 1,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Enhorabuena'
            },
            sideHelp: {
              text: "Enhorabuena"
            },
            quote: {
              text: null,
              author: null
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/Congratulations.vue'
          )
      },
      {
        path: 'info',
        name: 'onBoard.neofintech.phase3.info',
        meta: {
          prev: 'onBoard.neofintech.phase3.congratulations',
          next: null,
          name: 'Info',
          hasBottomBar: true,
          showNext: false,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#FFC10D',
              dark: '#cc9a09'
            },
            step: {
              number: 2,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Info'
            },
            sideHelp: {
              text: 'Información'
            },
            quote: {
              text: 'Q25T',
              author: 'Q25A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/Info.vue'
          )
      },
      {
        path: 'signup',
        name: 'onBoard.neofintech.phase3.signup',
        meta: {
          prev: null,
          next: null,
          name: 'Registro',
          hasBottomBar: true,
          showNext: false,
          hasSidebox: true,

          extra: {
            step: {
              number: 3,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            colors: {
              primary: '#FFC10D',
              dark: '#cc9a09'
            },
            sideHelp: {
              text: 'Cree su cuenta'
            },
            wheel: {
              text: 'Registro'
            },
            quote: {
              text: 'Q22T',
              author: 'Q22A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/Signup.vue'
          )
      },
      {
        path: 'actions',
        name: 'onBoard.neofintech.phase3.actions',
        meta: {
          prev: null,
          next: null,
          name: 'Registrado',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,

          extra: {
            step: {
              number: 4,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            colors: {
              primary: '#FFC10D',
              dark: '#cc9a09'
            },
            sideHelp: {
              text: 'Nombre del proyecto'
            },
            wheel: {
              text: 'Registrado'
            },
            quote: {
              text: 'Q23T',
              author: 'Q23A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/Actions.vue'
          )
      },
      {
        path: 'signed-nda',
        name: 'onBoard.neofintech.phase3.signedNDA',
        meta: {
          prev: null,
          next: null,
          name: 'NDA Firmado',
          hasBottomBar: true,
          hasSidebox: true,
          showNext: false,
          extra: {
            step: {
              number: 6,
              text: 'NDA Firmado',
              icon: 'hand_click'
            },
            colors: {
              primary: '#FFC10D',
              dark: '#cc9a09'
            },
            sideHelp: {
              text: 'NDA Firmado'
            },
            wheel: {
              text: 'NDA Firmado'
            },
            quote: {
              text: 'Q14T',
              author: 'Q14A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/SignedNDA.vue'
          )
      },
      {
        path: 'sent-nda',
        name: 'onBoard.neofintech.phase3.sentNDA',
        meta: {
          prev: null,
          next: null,
          name: 'NDA Enviado',
          hasBottomBar: true,
          hasSidebox: true,
          showNext: false,
          extra: {
            step: {
              number: 5,
              text: 'NDA Enviado',
              icon: 'hand_click'
            },
            colors: {
              primary: '#FFC10D',
              dark: '#cc9a09'
            },
            sideHelp: {
              text: 'NDA Enviado'
            },
            wheel: {
              text: 'NDA Enviado'
            },
            quote: {
              text: 'Q13T',
              author: 'Q13A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/SentNDA.vue'
          )
      },
      {
        path: 'conference',
        name: 'onBoard.neofintech.phase3.conference',
        meta: {
          prev: 'onBoard.neofintech.phase3.actions',
          next: null,
          name: 'Conferencia',
          hasBottomBar: true,
          showNext: true,
          extra: {
            colors: {
              primary: '#FFC10D',
              dark: '#cc9a09'
            },
            wheel: {
              text: 'Conferencia'
            },
            quote: {
              text: 'Q26T',
              author: 'Q26A'
            }
          }
        },
        component: () =>
          import( 
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/Conference.vue'
          )
      },
      {
        path: 'sign-contract',
        name: 'onBoard.neofintech.phase3.signContract',
        meta: {
          prev: null,
          next: null,
          name: 'Firmar contrato',
          hasBottomBar: true,
          showNext: true,
          extra: {
            colors: {
              primary: '#FFC10D',
              dark: '#cc9a09'
            },
            wheel: {
              text: 'Firmar contrato'
            },
            quote: {
              text: 'Q27T',
              author: 'Q27A'
            }
          }
        },
        component: () =>
          import( 
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/SignContract.vue'
          )
      },
  
      {
        path: 'signed-contract',
        name: 'onBoard.neofintech.phase3.signedContract',
        meta: {
          prev: null,
          next: null,
          name: 'Contrato Firmado',
          hasBottomBar: true,
          hasSidebox: true,
          showNext: true,
          extra: {
            step: {
              number: 7,
              text: 'Contrato Firmado',
              icon: 'hand_click'
            },
            colors: {
              primary: '#FFC10D',
              dark: '#cc9a09'
            },
            sideHelp: {
              text: 'Contrato Firmado'
            },
            wheel: {
              text: 'Contrato Firmado'
            },
            quote: {
              text: 'Q13T',
              author: 'Q13A'
            }
          }
        },
        component: () =>
          import( 
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/SignedContract.vue'
          )
      },
      {
        path: '/profile',
        name: 'onBoard.neofintech.profile',
        meta: {
          requiresAuth: true,
          hasBottomBar: false
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/Profile.vue'
          )
      },
      {
        path: 'finish',
        name: 'onBoard.neofintech.phase3.finish',
        meta: {
          prev: null,
          next: null,
          name: 'Final',
          hasBottomBar: true,
          showNext: true,
          extra: {
            colors: {
              primary: '#FFC10D',
              dark: '#cc9a09'
            },
            wheel: {
              text: 'Final'
            },
            quote: {
              text: 'Q29T',
              author: 'Q29A'
            }
          }
        },
        component: () =>
          import( 
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-3/Finish.vue'
          )
      },
    ],
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/phase-3/Phase3.vue'
      )
  }
]
